import { useSearchParams } from 'next/navigation'
import React, { Suspense } from 'react'

import BackButton, { type BackButtonPropsType } from './BackButton'

type Props = Omit<BackButtonPropsType, 'link'> & { link: string }

// this button is used mostly for webviews in app,
// where we need to keep the hideUi query param in the url
// this creates the problem with static rendering, so we need to use suspense
function BackButtonWithQueryForwarding(props: Props) {
  const component = <BackButton {...props} />
  return (
    <Suspense fallback={component}>
      <ParamForwardingWrapper {...props}>{component}</ParamForwardingWrapper>
    </Suspense>
  )
}

function ParamForwardingWrapper(props: Props & { children: React.ReactElement }) {
  const searchParams = useSearchParams()

  let query = {}
  searchParams.forEach((value, key) => {
    query = { ...query, [key]: value }
  })

  return React.cloneElement(props.children, { link: { pathname: props.link, query } })
}

export default BackButtonWithQueryForwarding
